import React from "react";
import InformationPage from "components/shared/InformationPage";
import ApiInformationPage from "models/data/api/ApiInformationPage";
import withApollo from "components/higher-order/withApollo";
import PageContainer from "components/containers/PageContainer";
import { useRecordPageView } from "hooks/analytics/useRecordPageView";
import { NextSeo } from "next-seo";

function EthicsPolicy() {
  useRecordPageView();
  const description =
    "Our ethics policy is to put all of our work through rigorous reporting, editing, and fact-checking. At our core, we are a journalism organization that is also building a community.";
  return (
    <PageContainer>
      <NextSeo
        title="Our Ethics Policy | The Juggernaut"
        description={description}
        twitter={{ cardType: "summary_large_image" }}
        openGraph={{
          title: "Our Ethics Policy",
          type: "website",
          site_name: "The Juggernaut",
          description,
        }}
      />
      <InformationPage page={ApiInformationPage.pages.ETHICS_POLICY} />
    </PageContainer>
  );
}

export default withApollo(EthicsPolicy);
